export const smoothScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const targetId = this.getAttribute('href');
      let targetPosition = 0;
      let shouldScroll = false;

      if (targetId === '#' || targetId === '') {
        targetPosition = 0;
        shouldScroll = true;
      } else {
        try {
          const targetElement = document.querySelector(targetId);
          if (targetElement) {
            targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
            shouldScroll = true;
          }
        } catch (e) {
          // Ignore invalid selectors
        }
      }

      if (shouldScroll) {
        const startPosition = window.pageYOffset;
        const distance = targetPosition - startPosition;
        const duration = 1000; // 1 second
        let start = null;

        // Easing function (ease-in-out)
        const easeInOutQuad = (t) => {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        };

        const animation = (currentTime) => {
          if (start === null) start = currentTime;
          const timeElapsed = currentTime - start;
          const progress = Math.min(timeElapsed / duration, 1);
          const ease = easeInOutQuad(progress);

          window.scrollTo(0, startPosition + distance * ease);

          if (timeElapsed < duration) {
            requestAnimationFrame(animation);
          }
        };

        requestAnimationFrame(animation);
      }
    });
  });
}